import { appConfig, isSingleUserMode } from '@/shared/config/env';

// 登录态在后端的 httpOnly 会话 cookie 里（Casdoor 登录流程，authFetch 默认带 credentials），
// 前端不再持有 token。这里只负责给请求带上「鉴权模式」标识：单用户模式额外带 user-id。
export const getAuthContext = () => {
  if (isSingleUserMode()) {
    return {
      mode: 'single',
      headers: {
        'x-candobear-auth-mode': 'single',
        'x-candobear-user-id': appConfig.singleUser.id,
      },
    };
  }

  return {
    mode: 'login',
    headers: {
      'x-candobear-auth-mode': 'login',
    },
  };
}
